import { render } from "./CustomerApplicationServices.vue?vue&type=template&id=5dd85eb2&scoped=true"
import script from "./CustomerApplicationServices.vue?vue&type=script&lang=js"
export * from "./CustomerApplicationServices.vue?vue&type=script&lang=js"

import "./CustomerApplicationServices.vue?vue&type=style&index=0&id=5dd85eb2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd85eb2"]])

export default __exports__